//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectShopModal from './components/select-shop-modal';
import SelectGoodModal from '../shop/components/select-good-modal';

export default {
  name: 'couponEdit',
  components: {SelectGoodModal, SelectShopModal},
  data() {
    return {
      id: 0,
      title: '',
      loading: false,
      rules: {
        name: [{required: true, message: '请输入优惠券名称', trigger: 'blur'}],
        type: [{required: true, type: 'number', message: '请选择优惠券类型', trigger: 'change'}],
        faceValue: [{required: true, type: 'number', message: '请输入面值或折扣', trigger: 'blur'}],
        quantity: [{required: true, type: 'number', message: '请输入总数', trigger: 'blur'}],
        goodName: [{required: true, message: '请选择商品', trigger: 'blur'}],
        shopName: [{required: true, message: '请选择商家', trigger: 'blur'}],
        // startTime: [{ required: true, type: 'date', message: '请选择生效日期', trigger: 'change' }],
        // endTime: [{ required: true, type: 'date', message: '请选择截止日期', trigger: 'change' }],
        releaseType: [{required: true, type: 'number', message: '请选择领取方式', trigger: 'change'}],
        channelType: [{required: true, type: 'number', message: '请选择发放途径', trigger: 'change'}],
        scope: [{required: true, type: 'number', message: '请选择使用范围', trigger: 'change'}]
      },
      coupon: {},
      showAddShopModal: false,
      showAddGoodModal: false,
      saving: false,
      options3: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },
  methods: {
    getById() {
      var vm = this;
      vm.loading = true;
      vm.$store.dispatch({
        type: 'coupon/GetCouponById',
        id: vm.id
      }).then(() => {
        vm.coupon = {};
        vm.coupon = vm.$store.state.coupon.cityInfo;
      }).finally(() => {
        vm.loading = false;
      });
    },
    onCancel() {
      // this.showEidtCouponModel = false;
    },
    onSave() {
      if (!this.coupon.startTime) {
        abp.message.error('请选择生效日期');
        return;
      }
      if (!this.coupon.endTime) {
        abp.message.error('请选择截止日期');
        return;
      }
      this.$refs.couponForm.validate(async (val) => {
        if (val) {
          this.saving = true;
          this.$store
              .dispatch({
                type: 'coupon/saveCoupon',
                data: this.coupon
              })
              .then(() => {
                this.$router.back();
              }).finally(() => {
            this.saving = false;
          });
        }
      });
    },
    delCoupon(row) {
      const vm = this;
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除' + row.name + '吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          await this.$store.dispatch({
            type: 'coupon/delCoupon',
            id: row.id
          }).then(() => {
            this.$Notice.success({
              duration: 3,
              title: '删除成功'
            });
            vm.getPage();
          }).finally(() => {

          });

        }
      });
    },
    startTimeChange(date) {
      this.coupon.startTime = date;
    },
    endTimeChange(date) {
      this.coupon.endTime = date;
    },
    showAddShop() {
      this.showAddShopModal = true;
    },
    addShop(shop) {
      this.coupon.shopName = shop.name;
      this.coupon.shopId = shop.id;
      // this.good.shopType = shop.shopType;

      this.coupon.goodId = 0;
      this.coupon.goodName = '';
      this.showAddShopModal = false;
    },
    showAddGood() {
      this.showAddGoodModal = true;
    },
    addGood(good) {
      this.coupon.goodName = good.goodName;
      this.coupon.goodId = good.id;
      this.coupon.shopId = good.shopId;
      this.showAddGoodModal = false;
    },
    scopeChange(val) {
      console.log(val);
    },
    channelTypeChange(val) {
      if (val == 4) {
        this.coupon.scope = 4;
      } else {
        this.coupon.scope = 0;
      }
      // this.coupon.scope = -1;
      // this.$refs.scopeRef.clearSingleSelect();
    }
  },
  created() {
    this.id = parseInt(this.$route.params.id) || 0;
    if (this.id > 0) {
      this.title = '编辑优惠券';
      this.getById();
    } else {
      this.title = '新增优惠券';
    }
  }
};
